import React, { useContext, useMemo } from "react";
import { WebsocketContext } from "../context/WebsocketContext";
import { MessageType, QuestionTypes } from "../context/sessionStore";
import useSessionStore from "../context/useSessionStore";
import { Question } from "./Question";
import { Answer } from "./Answer";

//region [[ Styles ]]
//endregion [[ Styles ]]

//region [[ Props ]]
export interface ChatProps {
  msgListRef: React.MutableRefObject<any>;
}
//endregion [[ Props ]]

export const ChatMessages = ({ msgListRef }: ChatProps) => {
  const {
    chatMessages,
    replyIsLoading,
    ragSettings,
    wsSessionId,
    autoScroll,
    loadGuideline,
  } = useSessionStore();

  const { getStream } = useContext(WebsocketContext);

  // const { answer, streamId, guidelines, altGuidelines } = useStreamingAnswer(
  //   ragSettings.wssEndpoint,
  //   wsSessionId,
  //   QuestionTypes.Chat,
  // );

  // useEffect(() => {
  //   setStreamId(streamId);
  // }, [streamId, setStreamId]);

  // useEffect(() => {
  //   if (!autoScroll) return;
  //
  //   if (answer || chatMessages?.length) {
  //     if (
  //       !answer &&
  //       chatMessages[chatMessages.length - 1]?.type ===
  //         MessageType.suggestedQuestions
  //     ) {
  //       chatMessages[chatMessages.length - 1].ref?.current?.scrollIntoView({
  //         behavior: "auto",
  //         block: "start",
  //       }); //scroll to suggested questions
  //     } else {
  //       if (msgListRef?.current) msgListRef.current.scrollToBottom("auto"); //scroll to bottom when answer is changed
  //     }
  //   }
  // }, [autoScroll, answer, chatMessages, msgListRef]);

  const streamedAnswer = useMemo(() => {
    const stream = getStream(wsSessionId, QuestionTypes.Chat);
    return (
      stream && (
        <Answer
          message={{
            index: chatMessages.length,
            text: stream.text,
            guidelines: stream.metadata?.guidelines?.concat(
              stream.metadata.altGuidelines,
            ),
            type: MessageType.answer,
          }}
          debugMode={ragSettings.debugMode}
          loading={true}
          key={"answer" + chatMessages.length}
          question={chatMessages[chatMessages.length - 1]?.text}
          getGuideline={loadGuideline}
        />
      )
    );
  }, [
    getStream,
    loadGuideline,
    wsSessionId,
    chatMessages,
    ragSettings.debugMode,
  ]);

  return (
    <>
      {chatMessages?.map((msg, idx) =>
        msg.type === MessageType.question ? (
          <Question msg={msg} key={"question" + idx} />
        ) : (
          <Answer
            message={msg}
            debugMode={ragSettings.debugMode}
            loading={false}
            key={"answer" + idx}
            question={chatMessages[idx - 1]?.text}
            getGuideline={loadGuideline}
          />
        ),
      )}
      {replyIsLoading(QuestionTypes.Chat) && streamedAnswer}
    </>
  );
};
